import {getFileVerification} from '@/services/fileUploadService';
import {uploadFileService} from '@/services/salesTargets';
import {useState} from 'react';

export const useFileUpload = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [progress, setProgress] = useState(0);
  const [fileUploadError, setFileUploadError] = useState('');

  const onUploadProgress = (progressEvent) => {
    const progress = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    // cap at 99% while in flight; the caller marks 100% once the response arrives
    setProgress(progress === 100 ? 99 : progress);
  };

  const onUploadFile = (file, onCallback, params = {}) => {
    const formData = new FormData();
    const {fileType} = params;
    formData.append('file', file);
    if (!fileType) {
      setFileUploadError('Upload Error');
      return;
    }
    formData.append('fileType', fileType);

    setIsUpdating(true);
    uploadFileService({formData, onUploadProgress})
      .then((response) => {
        onCallback(response);
        setIsUpdating(false);
        setProgress(0);
        setFileUploadError('');
      })
      .catch((error) => {
        const errMsg =
          error?.response?.data?.errorMessage ||
          error?.message ||
          'An unknown error occurred';
        setIsUpdating(false);
        setProgress(0);
        setFileUploadError(errMsg);
      });
  };

  const uploadFile = async (
    file,
    uploadFor,
    fileType,
    fieldName = 'file',
    extraFields = {}
  ) => {
    const formData = new FormData();
    formData.append(fieldName, file);
    Object.entries(extraFields).forEach(([key, value]) => {
      formData.append(key, value);
    });
    setProgress(0);
    try {
      const response = await getFileVerification(
        formData,
        uploadFor,
        onUploadProgress,
        fileType
      );
      setProgress(100);
      return response;
    } catch (error) {
      setProgress(0);
      throw error;
    }
  };

  return {
    onUploadFile,
    isUpdating,
    progress,
    fileUploadError,
    onUploadProgress,
    setFileUploadError,
    uploadFile
  };
};
